// extracted by mini-css-extract-plugin
export var avatarContainer = "_44-1";
export var largeAvatarContainer = "_44-2";
export var smallAvatarContainer = "_44-0";